module.exports = __webpack_public_path__ + "img/platform-dashboard.6f44f705.webp";